import { useMount } from "shelving/react";

/** Load a component from a JS `File` element and show it as an `<img>`. */
export function FileImage({ file }: { file: File }): React.ReactElement {
	return (
		<img
			ref={useMount(el => {
				const reader = new FileReader();
				reader.onload = () => {
					if (typeof reader.result === "string") el.src = reader.result;
				};
				reader.readAsDataURL(file);
			})}
			alt={file.name}
			title={file.name}
			draggable="false"
		/>
	);
}
